import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Ventrata} from 'types'

export const useGetProductsApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    (productIds: string[]) => {
      const fetchProduct = async (productId: string) => {
        const {data} = await ventrata.get<Ventrata.Product>(`/products/${productId}`, {
          headers: {
            'Octo-Capabilities': 'octo/pricing,octo/content',
          },
        })
        return data
      }
      return Promise.all(productIds.map(fetchProduct))
    },
    [ventrata]
  )
}
